import { type AnchorHTMLAttributes, forwardRef } from "react";

import { clsx } from "clsx";

import { MenuItem } from "./menu_item";

export const MenuItemAnchor = forwardRef<
  HTMLAnchorElement,
  AnchorHTMLAttributes<HTMLAnchorElement>
>(({ className, ...props }, ref) => (
  <MenuItem>
    <a
      ref={ref}
      className={clsx(
        "flex w-full cursor-pointer items-center gap-2 rounded-md px-3 py-2 font-medium text-slate-800 hover:bg-slate-200",
        className,
      )}
      {...props}
    />
  </MenuItem>
));
